// extracted by mini-css-extract-plugin
export default {"button":"styles_button__1Y-N1","icon":"styles_icon__-uTmv"};